import BlankEtc from '@components/blank/BlankEtc';
import Header from '@components/Header';
import InfinityScrollTrigger from '@components/InfinityScrollTrigger';
import Loading from '@components/Loading';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import NotificationItem from './components/NotificationItem';
import ReadAllButton from './components/ReadAllButton';
import useNotifications from './hooks/useNotifications';

declare module '@stackflow/config' {
    interface Register {
        NotificationActivity: {};
    }
}

const NotificationActivity: ActivityComponentType<'NotificationActivity'> = () => {
    const { t } = useTranslation('notification');
    const {
        notifications, fetchNextPage, isBlank, isFetching,
    } = useNotifications();
    return (
        <AppScreen>
            <Header title={t('title')} />
            {!isBlank && (<ReadAllButton/>)}
            {notifications?.map((notification) => (
                <NotificationItem notification={notification}
                    key={notification.notificationId} />
            ))}
            <InfinityScrollTrigger trigger={fetchNextPage} />
            {isFetching && (
                <Loading size='small'/>
            )}
            {isBlank && (
                <BlankEtc>
                    {t('empty')}
                </BlankEtc>
            )}

        </AppScreen>
    );
};

export default NotificationActivity;
